import { render } from "./MsgLeftNav.vue?vue&type=template&id=5c6d67a3&scoped=true"
import script from "./MsgLeftNav.vue?vue&type=script&lang=js"
export * from "./MsgLeftNav.vue?vue&type=script&lang=js"

import "./MsgLeftNav.vue?vue&type=style&index=0&id=5c6d67a3&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6d67a3"]])

export default __exports__